<template>
    <div>
        <cafe-write-link v-for="component in optionLayouts" :key="`cafeComp${component}`" :writeLayout="component"
                         :cafeData="cafeData" :setData="setData"></cafe-write-link>
    </div>
</template>

<script>
import VuxAlert from '@/mixins/vux-alert';
import cafeUtil from "@/components/justcafe/cafeUtil";
import CafeWriteLink from "@/components/justcafe/CafeWriteLink";
import CafeValidator from "@/mixins/validators/CafeValidator"
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import elFileMixins from "@/mixins/elFileMixins";

export default {
    name: 'CafeWriteComponent',
    components: {
        CafeWriteLink
    },
    mixins: [VuxAlert, cafeUtil, CafeValidator, elFileMixins],
    props: {
        cafeType: {
            type: String,
            default: () => {return ''}
        },
        cafeKey: {
            type : Number,
            default: () => {return 0}
            },
    },
    data() {
        return {
            optionLayouts: [],
            createApiParamSet: {},
            detailApiParamSet: {},
            directUrl: '',
            resultAlertTxt: '',
            validateAlertText: '',
            parsingData: {},
            cafeData: {},
            fileType: '',
            allowApiParamsSet:{},
            allowFunc:'',
            content:''
        }
    },
    mounted() {
    },
    watch: {},
    created() {
        this.initConfig();
        EventBus.$on('writeCafe', this.writeCafe);
        EventBus.$on('leaderOutConfirm', this.leaderOutConfirm);
        EventBus.$on('updateAllowAlert', this.updateAllowAlert);
    },
    beforeDestroy() {
        EventBus.$off('writeCafe');
        EventBus.$off('leaderOutConfirm');
        EventBus.$off('updateAllowAlert');
    },
    methods: {
        initConfig() {
            let cafeConfig = this.returnCafeConfig(this.cafeType)
            this.createApiParamSet = cafeConfig.createApiParamSet;
            this.detailApiParamSet = cafeConfig.detailApiParamSet;
            this.directUrl = cafeConfig.directUrl;
            this.resultAlertTxt = cafeConfig.resultAlertTxt;
            this.validateAlertText = cafeConfig.validateAlertText;
            this.parsingData = cafeConfig.parsingData;
            this.fileType = cafeConfig.fileType;
            this.allowFunc = cafeConfig.allowFunc;
            this.allowApiParamsSet = cafeConfig.allowApiParamsSet;

            if (this.cafeKey != 0) {
                this.getInfo();
            } else {
                this.initTemplate();
            }
        },
        initTemplate() {
            let cafeConfig = this.returnCafeConfig(this.cafeType)
            this.optionLayouts = cafeConfig.optionLayouts;
        },
        setData(key, value) {
            this[key] = value;
        },
        getInfo() {
            let params = JSON.parse(JSON.stringify(this.detailApiParamSet));
            params.id = this.cafeKey;
            try {
                this.$api.$cafe.getCafe(params).then(res => res.Data.Result).then(res => {
                    if (res.Info.type != 1) {
                        this.createAlert({
                            title: '알림',
                            content: '카페정보를 불러올 수 없습니다.',
                            btnText: '확인',
                            hide: () => {
                                this.$router.back();
                            }
                        })
                        return
                    }
                    this.cafeData = res.List[0]
                    EventBus.$emit('CafeDetailSetData','cafeName',this.cafeData.c_name)
                    this.initTemplate();
                });
            } catch (e) {
                console.log(e);
            }
        },
        writeCafe(coin) {
            if(coin){
                this.coin = coin;
            }
            let validateArr = Object.keys(this.parsingData);

            this.$validate(validateArr).then((success) => {
                if (!success) {
                    this.errorAlert(this.validateAlertText);
                    return false;
                }
                let params = JSON.parse(JSON.stringify(this.createApiParamSet));
                let dataKeys = Object.keys(this.parsingData);
                dataKeys.forEach(dataKey => {
                    params[this.parsingData[dataKey]] = this[dataKey];
                });
                if (this.cafeKey !== 0) {
                    params.c_idx = this.cafeKey
                }
                try {
                    this.$api.$cafe.updateCafe(params).then(res => res.Data.Result).then(res => {
                        let type = this.writeReturnType(res.Info.type);
                        if (type != true) {
                            this.errorAlert(type);
                            return false;
                        }
                        if (!util.isEmpty(this.deleteFiles)) {
                            this.removeFiles(this.deleteFiles)
                        }
                        let key = res.List
                        if (!util.isEmpty(this.fileType) && !util.isEmpty(this.files) && this.files.filter(file => file.hasOwnProperty('raw')).length > 0) {
                            this.uploadFiles(this.files, this.fileType, key).then(success => {
                                this.afterFunc();
                            });
                        } else {
                            this.afterFunc();
                        }

                    })
                } catch (e) {
                    console.log(e);
                }
            })
        },
        afterFunc() {
            if(this.allow){
                this.updateAllow();
            }else{
                this.createAlert({

                title: '확인',
                content: this.resultAlertTxt,
                btnText: '확인',
                hide: () => {
                    if (this.directUrl === '') {
                        this.getInfo();
                        return false;
                    }
                    if (this.directUrl === 'back') {
                        this.$router.back();
                        return false;
                    }
                    let url = this.directUrl;

                    this.$router.push(url);
                }
            })
            }
        },
        writeReturnType(type) {
            let typeNum = Number(type);
            switch (typeNum) {
                case 1:
                    return true;
                case -2:
                    return '중복된 카페명입니다.';
                case -3:
                    return '폐쇄한 카페입니다.';
                case -403:
                    return '권한이 없었습니다.';
                default:
                    return '카페수정에 실패하였습니다. 잠시 다시 시도해 주세요.';
            }
        },
        leaderOutConfirm() {
            this.createConfirm(
                {
                    title: '',
                    content: '리더 박탈시 해당 회원은 스탭으로 지정되며 카페의 리더는 JUSTREET가 됩니다.',
                    confirmText: '확인',
                    cancelText: '취소',
                    confirm: () => {
                        this.leaderOutConfirmTwo();
                    }
                }
            )
        },
        leaderOutConfirmTwo() {
            this.createConfirm(
                {
                    title: '',
                    content: '정말 리더를 박탈하시겠습니까?',
                    confirmText: '확인',
                    cancelText: '취소',
                    confirm: () => {
                        this.leaderOut();
                    }
                }
            )
        },
        leaderOut() {
            let params = {
                c_type: 'justreet',
                c_idx: this.cafeKey
            }
            try {
                this.$api.$cafe.deleteLeader(params).then(res => res.Data.Result).then(res => {
                    if (res.Info.type == 1) {
                        this.createAlert({
                            title: '',
                            content: '카페 리더가 JUSTREET로 변경되었습니다.',
                            btnText: '확인',
                            hide: () => {
                                if (this.directUrl === '') {
                                    this.getInfo();
                                    return false;
                                }
                                if (this.directUrl === 'back') {
                                    this.$router.back();
                                    return false;
                                }
                                let url = this.directUrl;

                                this.$router.push(url);
                            }
                        })
                    }else {
                        this.errorAlert('리더박탈에 실패하였습니다.')
                    }
                })
            } catch (e) {
                console.log(e)
            }
        },
        updateAllowAlert(allow){
            this.allow = allow+'';
            if(this.allow === '1'){this.content = '승인';}
            else if(this.allow === '2'){this.content = '바로승인';}
            else{this.content = '거절';}
            this.createConfirm({
                content: '정말'+this.content+ ' 하시겠습니까?',
                confirm: () => {
                    if(allow === 1){
                        this.openInputConfirm({
                            title: '개설비용',
                            confirmText: '확인',
                            cancelText: '취소',
                            placeholder: 'Coin',
                            inputType : 'number',
                            validator: (value) => {
                                if (!value) {
                                    return '코인을 입력해주세요'
                                }
                            },
                            confirm: this.writeCafe,
                        })
                    }else{
                        this.writeCafe();
                    }
                }
            })
        },
        updateAllow(){

            let params = JSON.parse(JSON.stringify(this.allowApiParamsSet));
            params.c_idx = this.cafeKey;
            params.allow = this.allow;
            if(params.allow === '1'){
                params.c_cost = this.coin*1;
            }
            this.$api.$cafe[this.allowFunc](params).then(res => res.Data.Result).then(res => {
                if (res.Info.type != 1 && res.List.length === 0) {
                    this.createAlert({
                        title: '',
                        content: this.content+'에 실패하였습니다.',
                        btnText: '확인',
                        hide: () => {
                            this.$router.back();
                        }
                    });
                    return;
                }else{
                    this.createAlert({
                        title: '',
                        content: this.content+' 되었습니다.',
                        btnText: '확인',
                        hide: () => {
                            this.$router.back();
                        }
                    });
                }
            })
        }

    }
}
</script>
